const isProtected = (route) => {
  const unprotectedRoutes = ['/login', '/login/success'];

  return !unprotectedRoutes.includes(route);
};

const security = { isProtected };

export default security;
